import type { AppDispatch } from 'src/state/store';
import { getAllStopStatuses } from './getAllStopStatues';
import { getPrimaryStopStatuses } from './getPrimaryStopStatuses';
import { getRoutes } from './getRoutes';

type RouteListArgs = {
  warehouseId: string;
  nightEnd: string;
  // Keeps the current routes on screen while they reload. The Issues page
  // needs it: an uncached load swaps its table for a spinner, unmounting the
  // rows and clearing the GM's selection.
  cached?: boolean;
};

// A provider mutation, or a dispatch status the courier dialog saw first,
// reaches the header now through this refresh; the Burq poll
// (useProviderRoutePolling) runs only on Burq screens, every 30 s.
export const refetchRouteList = (
  dispatch: AppDispatch,
  { warehouseId, nightEnd, cached }: RouteListArgs,
): void => {
  dispatch(getRoutes({ warehouseId, nightEnd, ...(cached ? { cached } : {}) }));
  dispatch(getAllStopStatuses({ warehouseId, nightEnd }));
  dispatch(getPrimaryStopStatuses({ warehouseId, nightEnd }));
};
